<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div id="app_version">Version {{ app_version }}</div>
    <div class="auth-inner py-2">
      <b-card class="mb-0">
        <b-card-title class="mb-1">
          Welcome to CloudEdu Pro! 👋
        </b-card-title>
        <b-card-text class="mb-2">
          Please sign-in to your account and start the adventure
        </b-card-text>

        <!-- form -->
        <validation-observer ref="loginForm" #default="{ invalid }">
          <b-form class="auth-login-form mt-2" @submit.prevent>
            <!-- username -->
            <b-form-group label-for="username" label="Username">
              <validation-provider #default="{ errors }" name="Username" rules="required">
                <b-form-input
                  id="username"
                  v-model="username"
                  placeholder="Username"
                  :state="errors.length > 0 ? false : null"
                  autocomplete="off"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- password -->
            <b-form-group>
              <div class="d-flex justify-content-between">
                <label for="password">Password</label>
              </div>
              <validation-provider #default="{ errors }" name="Password" rules="required">
                <b-input-group class="input-group-merge" :class="errors.length > 0 ? 'is-invalid' : null">
                  <b-form-input
                    id="password"
                    v-model="password"
                    :type="passwordFieldType"
                    class="form-control-merge"
                    :state="errors.length > 0 ? false : null"
                    placeholder="Password"
                    autocomplete="off"
                  />
                  <b-input-group-append is-text>
                    <feather-icon
                      class="cursor-pointer"
                      :icon="passwordToggleIcon"
                      @click="togglePasswordVisibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- submit button -->
            <b-button variant="primary" type="submit" block :disabled="invalid" @click="login">
              Sign in
            </b-button>
          </b-form>
        </validation-observer>

        <!-- Google 登入區 -->
        <div class="divider my-2"><div class="divider-text">or</div></div>
        <b-button variant="light" block class="google-btn" @click="loginWithGoogle">
          <img
            src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
            width="18"
            class="mr-1"
          />
          Sign in with Google
        </b-button>
      </b-card>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BButton, BForm, BFormInput, BFormGroup, BCard, BLink, BCardTitle, BCardText,
  BInputGroup, BInputGroupAppend, BFormCheckbox,
} from 'bootstrap-vue'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BButton, BForm, BFormInput, BFormGroup, BCard, BCardTitle, BCardText,
    BInputGroup, BInputGroupAppend, BFormCheckbox, ValidationProvider, ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      app_version: '',
      username: '',
      password: '',
      googleReady: false,
    }
  },
  created() {
    this.app_version = process.env.VUE_APP_VERSION
    console.log(process.env.VUE_APP_VERSION)
    localStorage.setItem('reader_action', 'staff_check_in')
    const checkGoogle = setInterval(() => {
      if (window.google && window.google.accounts && window.google.accounts.oauth2) {
        clearInterval(checkGoogle)
        this.googleReady = true
        console.log('✅ Google SDK ready')
      }
    }, 300)

  },
  methods: {

    loginWithGoogle() {
  const client = google.accounts.oauth2.initCodeClient({
    client_id: '85693277844-b5c1dar2jaqtnmk1mv9eahg8okbf7v78.apps.googleusercontent.com',
    scope: 'openid email profile https://www.googleapis.com/auth/admin.directory.user https://www.googleapis.com/auth/cloud-platform https://www.googleapis.com/auth/admin.directory.user.readonly',
    redirect_uri: 'postmessage',     // 必須
    ux_mode: 'popup',
    access_type: 'offline',          // 必須
    prompt: 'consent',               // 必須
    callback: (resp) => {
      console.log('Google Response:', resp)
      console.log('CODE:', resp.code)  // ⬅️ 你要的 code
      this.$http.post(process.env.VUE_APP_API_BASE + '/google-auth/', {
          data: resp
        }) .then(response => {
          this.fetchGoogleUserInfo(response.data.access_token)
      })
    }
  })
  client.requestCode()
},


    // 🚀 Google 登入
    // loginWithGoogle() {
    //   if (!this.googleReady) {
    //     alert('Google 登入 SDK 尚未載入，請稍等幾秒再試。')
    //     return
    //   }

    //   try {
    //     const client = google.accounts.oauth2.initTokenClient({
    //     //client_id: '316527243642-55na7hcmkpc4cr4ir2ld5e16uq3idtge.apps.googleusercontent.com',
    //     //  client_id: '287517629801-mvo8scocq3i9vc3tsig01jo17j903lrb.apps.googleusercontent.com',
    //       client_id : '85693277844-b5c1dar2jaqtnmk1mv9eahg8okbf7v78.apps.googleusercontent.com', //TKHC
    //       scope: 'openid email profile https://www.googleapis.com/auth/admin.directory.user https://www.googleapis.com/auth/cloud-platform https://www.googleapis.com/auth/admin.directory.user.readonly',
    //       ux_mode: 'popup',
    //       access_type: 'offline',   // 🔑 要這行，才會有 refresh_token
    //       prompt: 'consent',        // 🔑 強制要求用戶授權，否則 Google 唔會再發 refresh_token
    //       callback: (response) => {
    //         console.log('✅ Google Response:', response)
    //         this.exchangeCodeForToken(response.code)
    //         if (response.access_token) {
    //           // 取得 Google user info
    //           this.fetchGoogleUserInfo(response.access_token)
    //         } else {
    //           console.warn('⚠️ 無 access_token，登入被取消')
    //         }
    //       },
    //     })
    //     client.requestAccessToken()
    //   } catch (e) {
    //     console.error('❌ Google 登入錯誤：', e)
    //     alert('Google 登入初始化失敗，請重新整理頁面再試。')
    //   }
    // },

    // 🧠 用 access_token 向 Google 拿 email / name / picture
    async fetchGoogleUserInfo(access_token) {
      try {
        const res = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
          headers: { Authorization: `Bearer ${access_token}` },
        })
        const user = await res.json()
        console.log('👤 Google 使用者資料:', user)
        console.log('🔑 Google Token:', access_token)
        // 將 token 傳去你自己後端做 login
        this.googleLogin(access_token, user)
      } catch (err) {
        console.error('❌ 無法取得使用者資料:', err)
      }
    },

    // 📡 呼叫你 API /auth/google
    async googleLogin(token, user) {
      try {
        const res = await this.$http.post(process.env.VUE_APP_API_BASE + '/auth/', {
          token: token,
          version: this.app_version,
        })
        //console.log('✅ Server Response:', res.data)
        this.handleLoginResponse(res)
      } catch (err) {
        console.error('❌ Token 驗證失敗：', err)
      }
    },

    // 👤 普通帳號密碼登入
    login() {
      this.$http.post(process.env.VUE_APP_API_BASE + '/auth/', {
        username: this.username,
        password: this.password,
        version: this.app_version,
      })
        .then(res => this.handleLoginResponse(res))
    },

    // ✅ 登入成功統一處理
    handleLoginResponse(res) {
      if (res.data.result === true) {
         const userData = res.data
            localStorage.setItem('reader_action', 'normal')
            this.$store.commit('center/UPDATE_CENTER_ID', userData.default_center_id)
            this.$store.commit('center/UPDATE_CENTER_NAME', userData.default_center_name)
            this.$http.defaults.headers.Token = res.data.token
            this.$i18n.locale = 'en'
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: `Welcome ${userData.fullName}`,
                icon: 'CoffeeIcon',
                variant: 'success',
                text: `You have successfully logged in as ${userData.role}. Now you can start to explore!`,
              },
            })

            localStorage.setItem('userData', JSON.stringify(userData))
            this.$ability.update(userData.ability)
            this.$router.replace(userData.landing_url)
              .then(() => {

              })
           // console.log(userData.ability)
      } else {
        this.$toast({
          component: ToastificationContent,
          position: 'top-center',
          props: {
            title: 'Error',
            icon: 'XIcon',
            variant: 'danger',
            text: res.data.message,
          },
        })
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
#app_version {
  position: fixed;
  bottom: 10px;
  right: 10px;
  font-weight: bold;
}
.google-btn {
  border: 1px solid #dadce0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  color: #444;
}
.google-btn:hover {
  background: #f8f9fa;
}
</style>
